export default __webpack_public_path__ + "static/media/breakdown-blue.d0d2d910.png";